<template>
  <v-dialog
    v-model="dialog"
    width="800"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-toolbar>
        <v-toolbar-title>
          {{ $route.meta.nameDrawer }} Nº {{ $route.params.id }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="pa-4 grey lighten-1">
        <v-card class="white black--text pa-4">
          <div class="text-center py-10" v-show="progress">
            <v-progress-circular
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
          <div class="black--text text-right">{{ date }}</div>
          <div v-html="msg"></div>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "administrator-dashboard-notification-view",
  
  data: () => ({
    msg: "",
    title: "",
    date: null,
    progress: true,
  }),
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
  },

  async mounted() {
    try {
      const id_notification = this.$route.params.id;
      const response = await this.$request.post(
        "/administrator/notifications/getNotification",
        { id_notification }
      );
      if (response.length == 0) return;
      const { message, date_notification } = response.dados;
      this.msg = message;
      this.date = new Date(date_notification).toLocaleDateString();
    } finally {
      this.progress = false;
    }
  },
  methods: {
    closeDialog() {
      this.$router.go(-1);
      this.$store.commit("showDialog", false);
    },
  },
};
</script>
